import { ConditionalController } from './conditional.controller'

function conditional () {
  return {
    restrict: 'E',
    scope: {
      field: '=',
      sections: '<',
      currentSection: '<'
    },
    templateUrl: '/admin/directives/conditional/conditional-directive.html?$$REVISION$$',
    controller: ConditionalController
  }
}

export { conditional }
